import { useState } from 'react'
import { DocumentProps, Document, Page, pdfjs } from 'react-pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

interface Props extends DocumentProps {
  file: string
  scale?: number
  onLoadSuccess?: () => void
  // TODO: A bit of hack to deal with the header in `LegalDocBase`. Probably a better
  // way to deal with this via inspecting the dom to determine better scroll positioning.
  scrollToOffset?: number
}

const PdfViewer = ({ file, scale = 1, onLoadSuccess, scrollToOffset = 0, ...rest }: Props) => {
  const [numPages, setNumPages] = useState<number | null>(null)
  const handleLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages)
    onLoadSuccess && onLoadSuccess()
  }

  return (
    <Document
      {...rest}
      onItemClick={({ pageNumber }) => {
        const element = document.querySelector(`[data-page-number="${pageNumber}"`)
        const y = element!.getBoundingClientRect().top + window.pageYOffset + scrollToOffset
        window.scrollTo({ top: y, behavior: 'smooth' })
      }}
      file={file}
      onLoadSuccess={handleLoadSuccess}
    >
      {Array.from(new Array(numPages), (el, index) => (
        <Page scale={scale} key={`page_${index + 1}`} pageNumber={index + 1} />
      ))}
    </Document>
  )
}

export default PdfViewer
